.dialogContent {
  padding-top: 0;
  padding-bottom: 24px;
  background-color: #f5f5f5;
}

.searchBar {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 60px;
  padding-right: 16px;
  padding-left: 16px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
  z-index: 1;
}

.searchBar :global(.MuiInputBase-root) {
  align-items: center;
  height: 44px;
}

.searchBar :global(.MuiInputBase-input) {
  color: #757575;
  font-size: 20px;
  font-weight: 600;
}

.searchBar :global(input[type='search']) {
  appearance: textfield;
}

.searchBar :global(input[type='search']::-webkit-search-cancel-button) {
  display: none;
  appearance: none;
}

.groupLabel {
  position: static;
  padding: 0 4px;
  background-color: transparent;
  color: #757575;
  font-size: 16px;
  font-weight: 600;
  line-height: 48px;
}

.groupUl {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0 14px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgb(0 0 0 / 7%);
  list-style: none;
}

.listbox {
  margin: 0;
  padding: 0;
  list-style: none;
}

.optionGroup + .optionGroup {
  margin-top: 8px;
}

.option {
  position: relative;
  min-height: 46px;
}

.option:not(:last-child) {
  border-bottom: 1px solid var(--divider);
}

.optionAvatar {
  min-width: 56px;
  flex-shrink: 0;
}

.optionContent {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  min-height: 46px;
  padding: 8px 48px 8px 0;
  text-decoration: none;
  text-align: left;
  border: 0;
  cursor: pointer;
  user-select: none;
  border-radius: 0;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
}

.optionText {
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 4px;
  margin-bottom: 4px;
}

.secondaryAction {
  top: 50%;
  right: 0;
  position: absolute;
  transform: translateY(-50%);
}

.selectedHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 0 0 4px;
}

.selectedSection {
  padding-top: 8px;
}

.selectedList {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 15px;
  background-color: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgb(0 0 0 / 7%);
  list-style: none;
}

.selectedItem {
  display: flex;
  min-width: 0;
  max-width: 100%;
}

.selectedChip:global(.MuiChip-colorPrimary) {
  max-width: 100%;
  height: auto;
  min-height: 28px;
  color: var(--text-primary);
  font-size: 14px;
}

.selectedChip :global(.MuiChip-label) {
  padding: 4px 8px;
  overflow: visible;
  white-space: normal;
}

.selectedChip :global(.MuiChip-deleteIcon) {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  margin-left: -4px;
  color: rgb(255 255 255 / 70%);
}

.counter {
  align-items: center;
}

.badge:global(.MuiBadge-badge) {
  position: static;
  transform: translateX(10px);
  transform-origin: center;
}
